export const AppPageTitles = {
   default: 'Twoja pożyczka online | opena.pl',
   home: 'Twoja pożyczka online | opena.pl',
   howItWorks: 'Jak pożyczyć pieniądze prosto i szybko? | opena.pl',
   faq: 'Pytania i odpowiedzi na temat pożyczek | opena.pl',
   docsToDownload: 'Dokumenty do pobrania | opena.pl', 
   contact: 'Skontaktuj się z nami, infolinia, adres e-mail | opena.pl'
} 